// In main.js: Vue.mixin(datumConversie)

export default {
    methods: {
        // Geeft string '20251130' terug
        getJaarMaandDagNummerString(datum) {
            const jaar = datum.getFullYear()
            const maand = String(datum.getMonth() + 1).padStart(2,'0')
            const dag = String(datum.getDate()).padStart(2,'0')
            return `${jaar}${maand}${dag}`
        },
        // Geeft string '30 november 2025' terug
        getDatumTitelString(datum){
            return new Intl.DateTimeFormat(this.calendarLocale, {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }).format(datum);
        }
    }

}